module.exports = __webpack_public_path__ + "img/5.ff71fe5c.png";